import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { MachinesService } from 'src/app/_services/machines.service';
import { MessService } from 'src/app/_services/mess-service.service';

@Component({
  selector: 'app-machins-all',
  templateUrl: './machins-all.component.html',
  styleUrls: ['./machins-all.component.scss'],
})
export class MachinsAllComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  machines: any[];
  loading: boolean = true;

  constructor(
    private confirmationService: ConfirmationService,
    private messService: MessService,
    private machineService: MachinesService
  ) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */
  ngOnInit(): void {
    this.getData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */
  getData() {
    this.loading = true;
    this.subscriptions.push(
      this.machineService.getAllMachines().subscribe((machines) => {
        this.machines = machines;
        this.loading = false;
      })
    );
  }

  onEdit(machine) {
    this.machineService.updateMachineData.next(machine);
  }

  onDelete(event: Event, machineId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete operaciju?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscriptions.push(
          this.machineService.deleteMachine(machineId).subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Obrisali ste operaciju.',
              });
              this.getData();
            },
            (error) => {
              this.messService.add({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
              });
            }
          )
        );
      },
    });
  }
}
